export function EducationStoryDetails() {
  const STORY_PROMPTS = [
    'What do you remember most about your first day?',
    'Who took you to school?',
    'What were your feelings about starting school?'
  ]

  return (
    <div className="space-y-8">
      {/* Story Section */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Your Story</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          {STORY_PROMPTS.map((prompt) => (
            <div key={prompt} className="mb-8 last:mb-0">
              <label className="block text-lg text-gray-700 font-medium mb-3">
                {prompt}
              </label>
              <textarea
                className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
                placeholder="Share your memories..."
              />
            </div>
          ))}
        </div>
      </div>

      {/* People Involved */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">People Involved</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-wrap gap-4">
            {['Mom', 'Teacher', 'Best Friend'].map((person) => (
              <span
                key={person}
                className="px-6 py-3 text-lg rounded-full bg-gray-100 text-gray-700"
              >
                {person}
              </span>
            ))}
            <button className="px-6 py-3 text-lg rounded-full bg-[#556B2F] text-white">
              Add Person
            </button>
          </div>
        </div>
      </div>

      {/* Media Upload */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Photos & Documents</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="border-2 border-dashed border-[#556B2F] rounded-lg p-8 text-center">
              <span className="text-lg text-[#556B2F]">Upload Files</span>
            </div>
            <div className="space-y-4">
              <p className="text-lg text-gray-700">Suggested items:</p>
              <div className="grid grid-cols-2 gap-x-8 gap-y-2">
                <p className="text-lg text-gray-600">• First day photo</p>
                <p className="text-lg text-gray-600">• School ID/documents</p>
                <p className="text-lg text-gray-600">• Class photo</p>
                <p className="text-lg text-gray-600">• Report card</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 